import Provider from '@components/Provider';
import React from 'react';
import AppPresenter from './AppPresenter';
import FeedBackBtn from './FeedbackBtn';
const AppContainer: React.FC = () => {
  return (
    <Provider>
      <AppPresenter />
      <FeedBackBtn />
    </Provider>
  );
};

export default AppContainer;
